import { useLingui } from '@lingui/react/macro';
import { useMe } from '../profile/api';

export const useIdentification = () => {
  const me = useMe();
  const { t } = useLingui();
  const { kyc_docs_status, kyc_info_status } = me.data ?? {};
  if (kyc_docs_status === 'Verified') {
    return { label: t`Verified`, variant: 'positive' as const };
  }
  const status = kyc_docs_status ?? kyc_info_status;
  if (status === 'Approving') {
    return { label: t`In review`, variant: 'notice' as const };
  }
  if (status === 'Verification Failed') {
    return { label: t`Failed`, variant: 'negative' as const };
  }
  return { label: t`Unverified`, variant: 'notice' as const };
};
